import type {RepositoryNWO} from '@github-ui/current-repository'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {commitPath} from '@github-ui/paths'
import {Link} from '@github-ui/react-router'
import {Link as PrimerLink} from '@primer/react'
import {Fragment} from 'react'

import type {CommitExtended} from '../../../types/commit-types'
import {grabAndAppendUrlParameters} from '../../../utils/grab-and-append-url-parameters'
import {shortSha} from '../../../utils/short-sha'

type CommitParentsProps = {
  commit: CommitExtended
  repo: RepositoryNWO
}

export function CommitParents({commit, repo}: CommitParentsProps) {
  return (
    <>
      {`${commit.parents.length} parent${commit.parents.length > 1 || commit.parents.length === 0 ? 's' : ''} `}
      {commit.parents.map((parent, index) => (
        <CommitParentLink key={parent} parent={parent} index={index} repo={repo} />
      ))}
    </>
  )
}

function CommitParentLink({parent, index, repo}: {parent: string; index: number; repo: RepositoryNWO}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const hovercardAttrs = getHovercardAttributesForType('commit', {
    owner: repo.ownerLogin,
    repo: repo.name,
    commitish: parent,
  })
  return (
    <Fragment>
      {index !== 0 ? ' + ' : ''}
      <PrimerLink
        to={commitPath({owner: repo.ownerLogin, repo: repo.name, commitish: parent}) + grabAndAppendUrlParameters()}
        as={Link}
        className="color-fg-default Link--inTextBlock"
        data-hotkey={getParentHotkey(index)}
        {...hovercardAttrs}
      >
        {shortSha(parent)}
      </PrimerLink>
    </Fragment>
  )
}

function getParentHotkey(index: number) {
  switch (index) {
    case 0:
      return 'p'
    case 1:
      return 'o'
    default:
      return undefined
  }
}
